import { createApi } from '@reduxjs/toolkit/query/react';
import { API, API_PREFIX } from '../../constants';
import { baseQuery } from './base.query';

const serialize = function (obj: Record<string, unknown>): string {
  const str = [];
  for (const p in obj)
    if (Object.prototype.hasOwnProperty.call(obj, p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p] as string));
    }
  return '?' + str.join('&');
};

export const quickviewsApi = createApi({
  reducerPath: 'quickviewsApi',
  baseQuery: baseQuery,
  tagTypes: ['Feature'],
  endpoints: (builder) => ({
    getOverview: builder.query({
      query: (args) => ({
        url: API_PREFIX.NEXTGEN + API.QUICKVIEW + serialize(args),
      }),
    }),
    getOverviewInteractions: builder.query({
      query: (args) => {
        const { enabled, ...params } = args;
        if (!enabled) {
          return undefined as any as string;
        }
        return {
          url: API_PREFIX.NEXTGEN + API.QUICKVIEW_INTERACTIONS + serialize(params),
        };
      },
    }),
    getOverviewAlignments: builder.query({
      query: (args) => {
        const { enabled, ...params } = args;
        if (!enabled) {
          return undefined as any as string;
        }
        return {
          url: API_PREFIX.NEXTGEN + API.QUICKVIEW_ALIGNMENTS + serialize(params),
        };
      },
    }),
    getOverviewInsights: builder.query({
      query: (args) => {
        const { enabled, ...params } = args;
        if (!enabled) {
          return undefined as any as string;
        }
        return {
          url: API_PREFIX.NEXTGEN + API.QUICKVIEW_INSIGHTS + serialize(params),
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetOverviewQuery,
  useGetOverviewAlignmentsQuery,
  useGetOverviewInteractionsQuery,
  useGetOverviewInsightsQuery,
} = quickviewsApi;
